import { useCopyToClipboard } from '@consigli/hooks';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck, FaRegCopy } from 'react-icons/fa';

const DEFAULT_CLASS =
  'flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 transition-colors';

interface CopyButtonProps {
  textToCopy: string;
  label?: string;
  copiedLabel?: string;
  className?: string;
}

export const CopyButton: FC<CopyButtonProps> = ({ textToCopy, label, copiedLabel, className }) => {
  const { copied, copyToClipboard } = useCopyToClipboard();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => copyToClipboard(textToCopy)}
      className={className ?? DEFAULT_CLASS}
    >
      {copied ? <FaCheck className="w-3 h-3" /> : <FaRegCopy className="w-3 h-3" />}
      <span>
        {copied
          ? (copiedLabel ?? t('meeting-secretary.meetings.copied'))
          : (label ?? t('meeting-secretary.meetings.copy-all'))}
      </span>
    </button>
  );
};
